<template>
  <div class="page">
    <MyTitle type="2" title="日产量统计" class="title-scale"/>
    <div style="width: 100%; height: 100%">
      <MyEcharts
        v-if="showcdata"
        :id="'options24hour4342swarn1122'"
        :options="cdata"
      />
    </div>
  </div>
</template>

<script>
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import MyTitle from '@/views/exposition/components/title2'
import { dataInterface } from "@/api/dataInterfaceApi";
import * as echarts from "echarts";
export default {
  components: {
    MyTitle,
    MyEcharts,
  },
  data() {
    return {
      showcdata: false,
      // title:"车辆新增及活跃趋势",
      cdata: {
        title: [
          {
            text: "个",
            top: 120,
            left: 30,
            textStyle: {
              fontSize: 18, // 设置标题字体的大小
            },
          },
           {
            text: '%',
            right : 40,
            top: 120,
            textStyle: {
              fontSize: 18, // 设置副标题字体的大小
            },
          },
        ],
        // color: ['#0A9ABE','#FFD15C','#54CBCD','#FFD15C'],
        tooltip: {
          trigger: "axis",
          show: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
              // data: ['发电量', '收益', '周平均发电量', '周平均收益'],
            },
          },
        },

        legend: {
          itemWidth: 30, // 设置图例图标的宽度，单位为像素
          itemHeight: 20, // 设置图例图标的高度，单位为像素
          textStyle: {
            fontSize: 30, // 设置图例文字的大小，单位为像素
          },
        },
        grid: {
          top: "30%",
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: [],
        },
        yAxis: [
          {
            name: "",
            type: "value",
            splitLine: true,
          },
          {
            // name: "¥",
            type: "value",
            splitLine: true,
            itemStyle: {
              textAlign: "center",
            },
          },
        ],
        series: [
          //   {
          //     name: "目标产量",
          //     type: "bar",
          //     smooth: true,
          //     data: [],
          //     barWidth: 5,
          //     itemStyle: {
          //       normal: {
          //         color: new echarts.graphic.LinearGradient(
          //           0,
          //           1,
          //           0,
          //           0,
          //           [
          //             {
          //               offset: 0,
          //               color: "#0DB9E5", // 0% 处的颜色
          //             },
          //             {
          //               offset: 0.6,
          //               color: "#0C809D", // 60% 处的颜色
          //             },
          //             {
          //               offset: 1,
          //               color: "#0B4C5D", // 100% 处的颜色
          //             },
          //           ],
          //           false
          //         ),
          //       },
          //     },
          //     // tooltip: {
          //     //   valueFormatter: function (value) {
          //     //     return value + " kWh";
          //     //   },
          //     // },
          //   },
          {
            name: "实际产量",
            type: "line",
   
            smooth: true,
            data: [],
            lineStyle: {
              color: "#ffd15d",
            },
           
            // tooltip: {
            //   valueFormatter: function (value) {
            //     return value + " 元";
            //   },
            // },
          },
          {
            name: "合格率",
            type: "bar",
            barWidth: 30, // 设置
            yAxisIndex: 1,
            smooth: true,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  1,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: "#15F5C9", // 0% 处的颜色
                    },
                    {
                      offset: 0.6,
                      color: "#1E927C", // 60% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#1B3633", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + " %";
              },
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.getBattery24hours();
  },
  methods: {
    //获取24小时电次数分布
    getBattery24hours() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const timer = `${year}-${month}-${day}`;
      let params = {
        enCode: "snec-left-fadianqushi",
        "@dim_date": localStorage.getItem("changeDataNuber") || timer,
        "@harbour_id":
          localStorage.getItem("harbour_id") ||
          "76df7579ccc24d2693f6488c38a3a0b0",
      };
      this.showcdata = false;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "发电趋势");
          if (res) {
            let data = [];
            let data2 = [];
            let data3 = [];
            let xAxis = [];
            res.forEach((item) => {
              //   xAxis.push(item.dim_date);
              //   data.push(item.sum_output_elect);
              //   data2.push(item.sum_earnings);
              //   data3.push(item.weekly_average_output_elect);
            });
            let { hours } = this.getTimeFromMidnight();
            for (let i = 0; i <= 2; i++) {
              console.log(this.generateRandomNumber(2, 3))
              data.push(this.generateRandomNumber(2, 3) * hours);
            }
            for (let i = 0; i <= 2; i++) {
              data.push(this.generateRandomNumber(3, 4) * hours);
            }
            for (let i = 0; i <= 4; i++) {
              data2.push(this.generateRandomNumber(90, 98));
            }
            this.cdata.xAxis.data = [
              "产线1",
              "产线2",
              "产线3",
              "产线4",
              "产线5",
            ];
            // this.cdata.series[0].data = [60,60,60,70,70];
            this.cdata.series[0].data = data;
            this.cdata.series[1].data = data2;
            this.showcdata = true;
            console.log("this.cdataOptions", this.cdataOptions);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    generateRandomNumber(min, max) {
      var randomNumber = Math.random() * (max - min) + min;
      return Math.floor(randomNumber);
    },
    getTimeFromMidnight() {
      var now = new Date(); // 获取当前时间
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // 获取当天0点时间
      var diff = now - midnight; // 计算时间差（单位为毫秒）
      var hours = Math.floor(diff / (1000 * 60 * 60)); // 将时间差转换为小时
      var minutes = Math.floor((diff / (1000 * 60)) % 60); // 将时间差转换为分钟
      var seconds = Math.floor((diff / 1000) % 60); // 将时间差转换为秒钟

      return {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./page.scss";
</style>